import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { isReservedScheme, isValidScheme, normaliseScheme } from './scheme';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onValidity: (valid: boolean) => void;
  otherSchemes: string[];
  helperText?: string;
}

export default function SchemeField({ value, onChange, onValidity, otherSchemes, helperText }: Props) {
  const error = !value.trim()
    ? 'Leverandør-ID må fylles inn'
    : !isValidScheme(value)
      ? 'Bare bokstaver (a–z) og tall, uten mellomrom'
      : isReservedScheme(value)
        ? 'Denne ID-en er reservert'
        : otherSchemes.some((x) => normaliseScheme(x) === normaliseScheme(value))
          ? 'Leverandør-ID-en er allerede i bruk'
          : '';

  useEffect(() => {
    onValidity(!error);
    // onValidity is the parent's setter; only the answer should re-run this.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <TextField
      label="Leverandør-ID (scheme)"
      fullWidth
      required
      value={value}
      onChange={(event) => onChange(event.target.value)}
      error={!!error && !!value}
      helperText={(value && error) || helperText || ' '}
    />
  );
}
